import { useState, useMemo, useEffect } from 'react';
import { DataTable } from 'components';
import { parseISO, format } from 'date-fns';

const AnalyticsCampaignMetricsTable = ({ currentData, activeSource, loading, currency = "" }) => {
  const [offset, setOffset] = useState(0);
  const limit = 10;

  const allItems = useMemo(() => currentData?.daily_metrics || [], [currentData?.daily_metrics]);
  const totalItems = allItems.length;

  useEffect(() => {
    setOffset(0);
  }, [activeSource]);

  const paginatedItems = useMemo(() => {
    return allItems.slice(offset, offset + limit);
  }, [offset, allItems]);

  const columns = [
    {
      key: 'date',
      label: 'Fecha',
      field: 'date',
      render: (value) => {
        if (!value) return '-';
        try {
          const dateObj = parseISO(value);
          return format(dateObj, 'dd-MM-yyyy');
        } catch {
          return value;
        }
      }
    },
    {
      key: 'impressions',
      label: 'Impr.',
      field: 'impressions',
      format: 'number',
    },
    {
      key: 'clicks',
      label: 'Clicks',
      field: 'clicks',
      format: 'number',
    },
    {
      key: 'ctr',
      label: 'CTR',
      field: 'ctr',
      format: 'percentage',
    },
    {
      key: 'cost',
      label: `Costo (${currency})`,
      field: activeSource === 'google' ? 'cost' : 'total_cost',
      format: 'currency',
    },
    {
      key: 'conversions',
      label: 'Conv.',
      field: 'conversions',
      format: 'number',
    },
    {
      key: 'cost_per_conversion',
      label: `Costo por Conv. (${currency})`,
      field: 'cost_per_conversion',
      format: 'currency',
      render: (value, item) => {
        const cost = item.cost ?? 0;
        const conv = item.conversions ?? 0;
        const computed = value || (conv ? cost / conv : 0);
        return `${computed.toFixed(2)}`;
      }
    }    
  ];
  
  return (
    <DataTable
      columns={columns}
      items={paginatedItems}
      totalItems={totalItems}
      offset={offset}
      limit={limit}
      loading={loading}
      onPageChange={setOffset}
      emptyMessage="No hay datos disponibles para este periodo"
    />
  );
};

export default AnalyticsCampaignMetricsTable;
